<template>
  <validation-observer v-slot="{ invalid }" slim>
    <oie-edit-wrapper
      v-if="invoiceInformation"
      :title="t('invoicesHeader')"
      class="my-invoices-info"
      :disabled="!isUserAdmin"
      :contained="true">
      <template #preview-content>
        <div class="my-invoices-info__preview">
          <p>{{ invoiceInformation.invoiceAddress.name }}</p>
          <p>{{ invoiceInformation.invoiceAddress.addressLine1 }}</p>
          <p>
            <span>{{ invoiceInformation.invoiceAddress.postalCode }}</span>,
            <span>{{ invoiceInformation.invoiceAddress.city }}</span>
          </p>
          <p class="u-mb-half">
            <span>{{ invoiceInformation.invoiceAddress.countryName }}</span>
          </p>
          <p>
            <span>{{ t('invoiceReferenceLabel') }}: </span>
            <span>{{ invoiceInformation.invoiceReference ? invoiceInformation.invoiceReference : tStatic('notSpecifiedText') }}</span>
          </p>
          <p>
            <span>{{ t('pdfInvoiceLabel') }}: </span>
            <span>{{ invoiceInformation.pdfInvoice ? tStatic('genericYes') : tStatic('genericNo') }}</span>
          </p>
          <p v-if="invoiceInformation.pdfInvoice">
            <span>{{ tStatic('email') }}: </span>
            <span>{{ invoiceInformation.pdfInvoiceEmail }}</span>
          </p>
        </div>
      </template>
      <template #edit-actions="{ toggle }">
        <oie-action-wrapper>
          <oie-base-action size="large" theme="skeleton" @click="exit(toggle)">
            {{ tStatic('genericClose') }}
          </oie-base-action>
          <oie-base-action
            size="large"
            :disabled="invalid"
            @click="save(toggle)">
            {{ tStatic('genericSave') }}
          </oie-base-action>
        </oie-action-wrapper>
      </template>
      <template #edit-content>
        <oie-address-component
          id="invoice"
          :address="invoiceInformation.invoiceAddress"
          :use-country-dropdown="false"
          class="u-mb-half"></oie-address-component>

        <oie-base-input-v2
          v-model="invoiceInformation.invoiceReference"
          class="u-mb-half"
          :label="t('invoiceReferenceLabel')"
          :placeholder="t('invoiceReferencePlaceholderLabel')">
        </oie-base-input-v2>

        <oie-base-radio-checkbox
          v-model="invoiceInformation.pdfInvoice"
          :label="t('pdfInvoiceLabel')"
          class="u-mb-half"></oie-base-radio-checkbox>

        <validation-provider
          v-if="invoiceInformation.pdfInvoice"
          v-slot="{errors}"
          rules="required|email"
          slim>
          <oie-base-input-v2
            v-model="invoiceInformation.pdfInvoiceEmail"
            :errors="errors"
            :label="tStatic('email')"
            :placeholder="tStatic('emailPlaceholder')"
            required></oie-base-input-v2>
        </validation-provider>
      </template>
    </oie-edit-wrapper>
  </validation-observer>
</template>

<script>
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  data() {
    return {
      invoiceInformation: null,
      pristineInvoiceInformation: null

    }
  },
  computed: {
    isUserAdmin() {
      return this.clientModel.user.isUserAdmin || this.clientModel.impersonating !== null
    }
  },
  async mounted() {
    const response = await httpService.get('auth/myinvoiceinformation')
    this.invoiceInformation = _.merge({}, this.invoiceInformation, response.data)
    this.pristineInvoiceInformation = _.merge({}, this.invoiceInformation, response.data)
  },
  methods: {
    async save(toggle) {
      await httpService.post('auth/myinvoiceinformation', this.invoiceInformation)
      this.pristineInvoiceInformation = _.merge({}, this.invoiceInformation)
      toggle()
    },
    exit(toggle) {
      this.invoiceInformation = _.merge({}, this.pristineInvoiceInformation)
      toggle()
    }
  }
}
</script>

<style lang="scss">
.my-invoices-info__preview p {
  @include body-smaller;
  margin: 0;
}
</style>
